import store from '../store'
import {isEmpty} from "./utils";

const PERMISSIONS = {
    //往来数据查询 销售订单页面
    'view_saleorder':{blockName:'erp',pageName:'saleOrder',codename:'view_saleorder'},//查询销售单
    //往来数据查询 销售出库单页面
    'view_outbound':{blockName:'erp',pageName:'outbound',codename:'view_outbound'},//查询销售出库单
    //询价单 包含详情
    'view_quotation':{blockName:'rfq',pageName:'inquirySheetList',codename:'view_quotation'},//查询询报价单
    'add_quotation':{blockName:'rfq',pageName:'inquirySheetList',codename:'add_quotation'},//添加询报价单
    'change_quotation':{blockName:'rfq',pageName:'inquirySheetList',codename:'change_quotation'},//修改询报价单
    'delete_quotation':{blockName:'rfq',pageName:'inquirySheetList',codename:'delete_quotation'},//删除询报价单
    'view_quotationentry':{blockName:'rfq',pageName:'inquirySheetList',codename:'view_quotationentry'},//查询询报价单详情
    'add_quotationentry':{blockName:'rfq',pageName:'inquirySheetList',codename:'add_quotationentry'},//添加询报价单详情
    'change_quotationentry':{blockName:'rfq',pageName:'inquirySheetList',codename:'change_quotationentry'},//修改询报价单详情
    'delete_quotationentry':{blockName:'rfq',pageName:'inquirySheetList',codename:'delete_quotationentry'},//删除询报价单详情
    'view_entry_stock_column':{blockName:'rfq',pageName:'inquirySheetList',codename:'view_entry_stock_column'},//删除询报价单详情
    //报价单 含详情
    'view_quotation1':{blockName:'rfq',pageName:'quotationList',codename:'view_quotation1'},//查询询报价单
    'add_quotation1':{blockName:'rfq',pageName:'quotationList',codename:'add_quotation1'},//添加询报价单
    'change_quotation1':{blockName:'rfq',pageName:'quotationList',codename:'change_quotation1'},//修改询报价单
    'delete_quotation1':{blockName:'rfq',pageName:'quotationList',codename:'delete_quotation1'},//删除询报价单
    'view_quotationentry1':{blockName:'rfq',pageName:'quotationList',codename:'view_quotationentry1'},//查询询报价单详情
    'add_quotationentry1':{blockName:'rfq',pageName:'quotationList',codename:'add_quotationentry1'},//添加询报价单详情
    'change_quotationentry1':{blockName:'rfq',pageName:'quotationList',codename:'change_quotationentry1'},//修改询报价单详情
    'delete_quotationentry1':{blockName:'rfq',pageName:'quotationList',codename:'delete_quotationentry1'},//删除询报价单详情
    //确认单 含详情
    'view_quotation2':{blockName:'rfq',pageName:'confirmationSheetList',codename:'view_quotation2'},//查询询报价单
    'add_quotation2':{blockName:'rfq',pageName:'confirmationSheetList',codename:'add_quotation2'},//添加询报价单
    'change_quotation2':{blockName:'rfq',pageName:'confirmationSheetList',codename:'change_quotation2'},//修改询报价单
    'delete_quotation2':{blockName:'rfq',pageName:'confirmationSheetList',codename:'delete_quotation2'},//删除询报价单
    'view_quotationentry2':{blockName:'rfq',pageName:'confirmationSheetList',codename:'view_quotationentry2'},//查询询报价单详情
    'add_quotationentry2':{blockName:'rfq',pageName:'confirmationSheetList',codename:'add_quotationentry2'},//添加询报价单详情
    'change_quotationentry2':{blockName:'rfq',pageName:'confirmationSheetList',codename:'change_quotationentry2'},//修改询报价单详情
    'delete_quotationentry2':{blockName:'rfq',pageName:'confirmationSheetList',codename:'delete_quotationentry2'},//删除询报价单详情

    //折扣管理 折扣策略页面
    'view_materialgroupdiscount':{blockName:'dms',pageName:'discountManagement',codename:'view_materialgroupdiscount'},//查询折扣管理
    'add_materialgroupdiscount':{blockName:'dms',pageName:'discountManagement',codename:'add_materialgroupdiscount'},//添加折扣管理
    'change_materialgroupdiscount':{blockName:'dms',pageName:'discountManagement',codename:'change_materialgroupdiscount'},//修改折扣管理
    'delete_materialgroupdiscount':{blockName:'dms',pageName:'discountManagement',codename:'delete_materialgroupdiscount'},//删除折扣管理
    //客户基础信息
    'view_customer':{blockName:'cms',pageName:'customerManage',codename:'view_customer'},//查询客户
    'add_customer':{blockName:'cms',pageName:'customerManage',codename:'add_customer'},//添加客户
    'change_customer':{blockName:'cms',pageName:'customerManage',codename:'change_customer'},//修改客户
    'delete_customer':{blockName:'cms',pageName:'customerManage',codename:'delete_customer'},//删除客户
    //基础数据--部门
    'view_organization':{blockName:'mad',pageName:'department',codename:'view_organization'},//查询部门
    'add_organization':{blockName:'mad',pageName:'department',codename:'add_organization'},//添加部门
    'change_organization':{blockName:'mad',pageName:'department',codename:'change_organization'},//修改部门
    'delete_organization':{blockName:'mad',pageName:'department',codename:'delete_organization'},//删除部门
    //基础数据 --职员
    'view_personnel':{blockName:'mad',pageName:'personnel',codename:'view_personnel'},//查询职员
    'add_personnel':{blockName:'mad',pageName:'personnel',codename:'add_personnel'},//添加职员
    'change_personnel':{blockName:'mad',pageName:'personnel',codename:'change_personnel'},//修改职员
    'delete_personnel':{blockName:'mad',pageName:'personnel',codename:'delete_personnel'},//
    //基础数据 --物料
    'view_material':{blockName:'mad',pageName:'material',codename:'view_material'},//查询物料
    'add_material':{blockName:'mad',pageName:'material',codename:'add_material'},//添加物料
    'change_material':{blockName:'mad',pageName:'material',codename:'change_material'},//修改物料
    'delete_material':{blockName:'mad',pageName:'material',codename:'delete_material'},//删除物料
    //系统管理 --用户
    'view_user':{blockName:'sms',pageName:'user',codename:'view_user'},//查询用户
    'add_user':{blockName:'sms',pageName:'user',codename:'add_user'},//添加用户
    'change_user':{blockName:'sms',pageName:'user',codename:'change_user'},//修改用户
    'delete_user':{blockName:'sms',pageName:'user',codename:'delete_user'},//删除用户

    //系统管理用户权限
    'view_group':{blockName:'sms',pageName:'permissions',codename:'view_group'},//查询用户组
    'add_group':{blockName:'sms',pageName:'permissions',codename:'add_group'},//添加用户组
    'change_group':{blockName:'sms',pageName:'permissions',codename:'change_group'},//修改用户组
    'delete_group':{blockName:'sms',pageName:'permissions',codename:'delete_group'},//删除用户组
    'view_permission':{blockName:'sms',pageName:'permissions',codename:'view_permission'},//查询权限
    'add_permission':{blockName:'sms',pageName:'permissions',codename:'add_permission'},//添加权限
    'change_permission':{blockName:'sms',pageName:'permissions',codename:'change_permission'},//修改权限
    'delete_permission':{blockName:'sms',pageName:'permissions',codename:'delete_permission'},//删除权限
}
Object.freeze(PERMISSIONS);

// 检测某个用户是否有某项权限
function checkPermission(permissionId){
    let permissionObj = PERMISSIONS[permissionId];
    let isHavePermission = checkUserPermission(permissionObj);
    if(!isHavePermission){
        isHavePermission = checkGroupPermission(permissionObj);
    }
    return isHavePermission;
}
function checkUserPermission(permissionObj){
    let isHavePermission = false;
    const userPermission = store.getters["user/userPermission"];
    let block = userPermission.find(item=>{
        return item.name == permissionObj.blockName;
    });
    if(isEmpty(block)){
        return false
    }
    let page = block.children.find(item=>{
        return item.name == permissionObj.pageName;
    });
    if(isEmpty(page)){
        return false
    }
    isHavePermission = page.model.some(item=>{
        if(item.codename == permissionObj.codename && item.status){
            return true
        }else{
            return false
        }
    })
    return isHavePermission
}

function checkGroupPermission(permissionObj){
    let isHavePermission = false;
    return isHavePermission
}
export {
    checkPermission,
    PERMISSIONS
}
